var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPuffucircleLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 230,
    viewBox: "0 0 230 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M222 115C222 174.094 174.094 222 115 222C55.9055 222 8 174.094 8 115C8 55.9055 55.9055 8 115 8C174.094 8 222 55.9055 222 115Z",
    fill: "white",
    stroke: "#FE531F",
    strokeWidth: 16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.56 143.865C102.086 142.024 100.914 137.001 100.642 134.109L96.2857 143.619L100.775 146.698L108.56 143.865Z",
    fill: "#FE531F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.5 140.5C106.5 139.3 104.667 135 104.5 133L104 140.5H112.5Z",
    fill: "#FE531F",
    stroke: "#FE531F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3086 118.558H104.841V127.915V133.971V140.028H112H119.247C124.375 140.028 128.037 139.304 129.746 138.098C131.455 136.892 132.432 133.756 132.432 129.413V118.558H172.964V116.387C172.964 127.001 172.232 136.168 170.767 143.405C169.302 150.642 166.616 156.673 162.709 161.256C158.803 165.84 153.187 169.217 146.106 171.147C139.025 173.077 129.746 174.042 118.514 174.042C107.283 174.042 98.0041 173.077 90.9232 171.147C83.8422 169.217 78.2263 165.84 74.3196 161.256C70.4129 156.673 67.727 150.642 66.262 143.405C64.797 135.927 64.0645 127.001 64.0645 116.387V118.558H64.3086Z",
    fill: "#FE531F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8635 105.773C92.3031 105.773 99.9555 98.2126 99.9555 88.8865C99.9555 79.5603 92.3031 72 82.8635 72C73.4238 72 65.7715 79.5603 65.7715 88.8865C65.7715 98.2126 73.4238 105.773 82.8635 105.773Z",
    fill: "#FE531F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M150.74 105.773C160.18 105.773 167.832 98.2126 167.832 88.8865C167.832 79.5603 160.18 72 150.74 72C141.301 72 133.648 79.5603 133.648 88.8865C133.648 98.2126 141.301 105.773 150.74 105.773Z",
    fill: "#FE531F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuffucircleLogo);
export default __webpack_public_path__ + "static/media/puffucircleLogo.d1aa55fe876a5d9f463df13a14b8eb5d.svg";
export { ForwardRef as ReactComponent };